import request from 'utils/request'
import { LENGJ_HEADERS } from '@/config/lengj-index'

// 获取经营数据
export const getEnterpriseFinanceSituation = data => {
  return request().post(
    'riskraider/v3/finance/getEnterpriseFinanceSituation',
    data,
    {
      headers: LENGJ_HEADERS,
    },
  )
}
